import React, { useState, useRef } from 'react';
import {
    X,
    ChevronLeft,
    MoreHorizontal,
    Copy,
    SquareArrowOutUpRight,
} from 'lucide-react';
import { useHistory } from 'react-router-dom';
import noImage from '../assets/img/brand/noImage.png';

const TradeInListingDrawer = ({ row, onClose, isArchived = false, currentPage = 1, onToggleStatus, onArchive, onSpuClick }) => {
    const history = useHistory();
    const [drawerTab, setDrawerTab]               = useState('general');
    const [copied, setCopied]                     = useState(false);
    const [toolbarDropdownOpen, setToolbarDropdownOpen] = useState(false);
    const toolbarRef = useRef(null);
    
    const formatDateTime = (isoString) => {
        const date = new Date(isoString);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}`;
    };
    if (!row) return null;

    // ── Overflow helper (same logic as BrandInfoDrawer) ──────────────────────
    const isNameOverflowing = (name) => name && name.length > 30;

    // ── Copy handler ─────────────────────────────────────────────────────────
    const handleCopy = async (text) => {
        if (!text) return;
        if (window.isSecureContext && navigator.clipboard?.writeText) {
            try {
                await navigator.clipboard.writeText(text);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            } catch {
                fallbackCopy(text);
            }
        } else {
            fallbackCopy(text);
        }
    };

    const fallbackCopy = (text) => {
        try {
            const ta = document.createElement('textarea');
            ta.value = text;
            ta.style.position = 'fixed';
            ta.style.opacity  = '0';
            document.body.appendChild(ta);
            ta.focus();
            ta.select();
            const ok = document.execCommand('copy');
            document.body.removeChild(ta);
            if (ok) {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            }
        } catch (err) {
            console.error('Copy failed', err);
        }
    };

    // ─────────────────────────────────────────────────────────────────────────
    return (
        <>
            {/* Overlay */}
            <div className="drawer-overlay" onClick={onClose} />

            {/* Drawer panel */}
            <div className="entity-drawer">

                {/* ── Header ── */}
                <div
                    className="drawer-header"
                    style={{ backgroundColor: '#F8F9FA',padding:'15px 20px' }}
                >
                    <div className="d-flex align-items-center gap-1">
                        
                        <h3>Listing Info</h3>
                    </div>
                    <button className="close-btn" onClick={onClose}>
                        <X size={18} />
                    </button>
                </div>

                {/* ── Body ── */}
                <div className="main-drawer-inner" style={{padding:'15px 20px'}}>

                    {/* Title row: image + name + actions */}
                    <div
                        className="drawer-title d-flex align-items-center justify-content-between"
                        style={{
                            borderBottom:  'none',
                            paddingBottom: '15px',
                            boxShadow:     'none',
                            marginBottom:  '0px',
                            display:       'flex',
                            alignItems:    'center',
                            justifyContent:'space-between',
                            flexWrap:      'nowrap',
                            width:         '100%',
                        }}
                    >
                        <div className="d-flex align-items-center">
                            <img
                                src={row.tradein_image_url || noImage}
                                alt={row.listing_model}
                                style={{
                                    width:  40,
                                    height: 40,
                                    objectFit: 'cover',
                                    marginRight: 8,
                                    verticalAlign: 'middle',
                                }}
                            />
                            <h2 style={{ textTransform: 'none' }} className="pb-0">
                                {row.listing_model}
                            </h2>
                        </div>

                        {/* Edit + more-options (hidden for archived listings) */}
                        {!isArchived && (
                            <div className="entities-tab" style={{padding:'0px'}}>
                                <div className="toolbar">
                                    <div
                                        className="toolbar-right"
                                        style={{ position: 'relative', flexWrap: 'nowrap' }}
                                        ref={toolbarRef}
                                    >
                                        <div
                                            className="edit-organisation-info d-flex justify-content-end align-items-center gap-2"
                                            style={{
                                                flexShrink: 0,
                                                whiteSpace:  'nowrap',
                                                display:     'flex',
                                                alignItems:  'center',
                                                gap:         '8px',
                                            }}
                                        >
                                            <button
                                                className="dark-border gray-btn"
                                                type="button"
                                                style={{ width: '100px',height:'34px',padding:'10px',display:'flex',alignItems:'center',justifyContent:'center' }}
                                                onClick={() => history.push('/trade-in-listing/edit-listing', { listing: row })}
                                            >
                                                Edit
                                            </button>
                                        </div>
                                        <button
                                            className="drawer-dots"
                                            style={{
                                                borderRadius: '8px',
                                                background: toolbarDropdownOpen ? '#FFF' : 'transparent',
                                                display: 'flex',
                                                padding: '8px',
                                                alignItems: 'center',
                                                gap: '10px',
                                                boxShadow: toolbarDropdownOpen ? '0 1px 4px 0 rgba(0, 0, 0, 0.10)' : 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                                transition: 'all 0.15s ease',
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setToolbarDropdownOpen(prev => !prev);
                                            }}
                                        >
                                            <MoreHorizontal size={18} />
                                        </button>

                                        {toolbarDropdownOpen && (
                                            <div
                                                className="backdrop-cls"
                                                style={{
                                                    position:     'absolute',
                                                    top:          44,
                                                    right:        0,
                                                    background:   'white',
                                                    boxShadow:    '0px 1px 4px 0px #0000001A',
                                                    zIndex:       1000,
                                                    minWidth:     160,
                                                    borderRadius: 8,
                                                }}
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <div className="btn-align-forall">
                                                    <div className="common-for-all">
                                                        <button onClick={() => {
                                                            setToolbarDropdownOpen(false);
                                                            history.push('/trade-in-listing/items', { listing: row, returnPage: currentPage, returnDrawerId: row.tradein_listing_id });
                                                        }}>
                                                            View All Items
                                                        </button>
                                                    </div>
                                                    <div className="common-for-all">
                                                        <button onClick={() => {
                                                            setToolbarDropdownOpen(false);
                                                            if (onToggleStatus) onToggleStatus(row);
                                                        }}>
                                                            {row.listing_status === 'Active' ? 'Deactivate' : 'Activate'}
                                                        </button>
                                                    </div>
                                                    <div className="common-for-all">
                                                        <button
                                                            className="deactivate-cls"
                                                            onClick={() => {
                                                                setToolbarDropdownOpen(false);
                                                                if (onArchive) onArchive(row);
                                                            }}
                                                        >
                                                            Archive
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* ── Tabs ── */}
                    <div
                        className="drawer-tabs"
                        style={{
                            padding:      '20px 0px',
                            gap:          '20px',
                            marginBottom: '0px',
                            borderBottom:"none"
                        }}
                    >
                        <button
                            className={drawerTab === 'general' ? 'active' : ''}
                            onClick={() => setDrawerTab('general')}
                        >
                            General
                        </button>
                        <button
                            className={drawerTab === 'additional-info' ? 'active' : ''}
                            onClick={() => setDrawerTab('additional-info')}
                        >
                            Additional
                        </button>
                    </div>

                    {/* ── Tab Content ── */}
                    <div className="drawer-content">

                        {/* ════════ GENERAL TAB ════════ */}
                        {drawerTab === 'general' && (
                            <div className="tab-panel general-panel">

                                {/* ── Basic Info Card ── */}
                                <div
                                    className="card-section"
                                    style={{
                                        borderRadius:  '12px',
                                        boxShadow:     '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                        overflow:      'hidden',
                                        marginBottom:  '20px',
                                        // marginTop:     '20px',
                                    }}
                                >
                                    {/* Card header */}
                                    <div
                                        className="card-header"
                                        style={{
                                            backgroundColor: '#F8F9FA',
                                            padding:         '15px 20px',
                                            fontFamily:      'Montserrat',
                                            fontSize:        '14px',
                                            fontWeight:       600,
                                            color:           '#212529',
                                            display:         'flex',
                                            alignItems:      'center',
                                            alignSelf:       'stretch',
                                            borderRadius:    '12px 12px 0px 0px',
                                            gap:             '10px',
                                            height:          '50px',
                                            borderBottom:'none'
                                        }}
                                    >
                                        Basic Info
                                    </div>

                                    {/* Card body */}
                                    <div
                                        className="card-body"
                                        style={{
                                            backgroundColor:  '#FFFFFF',
                                            padding:          '10px 20px',
                                            display:          'grid',
                                            gridTemplateColumns: 'repeat(2, 1fr)',
                                            gap:              '20px',
                                        }}
                                    >
                                        {/* Listing Model */}
                                        <div
                                            className="field-block"
                                            style={{
                                                borderBottom:   'none',
                                                display:        'flex',
                                                flexDirection:  'column',
                                                // minHeight:      '60px',
                                                gridColumn: isNameOverflowing(row.listing_model) ? '1 / -1' : '1',
                                                gridRow: '1',
                                                padding:'0px'
                                            }}
                                        >
                                            <div className="field-label">Listing Model</div>
                                            <div
                                                className="field-value d-flex align-items-center"
                                                style={{ gap: '10px', wordWrap: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal' }}
                                            >
                                                <img
                                                    src={row.tradein_image_url || noImage}
                                                    alt={row.listing_model}
                                                    style={{ width: 32, height: 32, objectFit: 'cover', flexShrink: 0 }}
                                                />
                                                {row.listing_model || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                            </div>
                                        </div>

                                        {/* Status (hidden for archived listings) */}
                                        {!isArchived && (
                                            <div
                                                className="field-block"
                                                style={{
                                                    borderBottom:  'none',
                                                    display:       'flex',
                                                    flexDirection: 'column',
                                                    gridColumn: isNameOverflowing(row.listing_model) ? '1' : '2',
                                                    gridRow: isNameOverflowing(row.listing_model) ? '2' : '1',
                                                    padding:'0px'
                                                }}
                                            >
                                                <div className="field-label">Status</div>
                                                <div className="field-value">
                                                    <span className={`status ${row.listing_status?.toLowerCase()}`}>
                                                        {row.listing_status || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                    </span>
                                                </div>
                                            </div>
                                        )}

                                        {/* ID */}
                                        <div
                                            className="field-block"
                                            style={{ borderBottom: 'none', padding: '0px' }}
                                        >
                                            <div className="field-label">ID</div>
                                            <div className="field-value">
                                                {row.listing_code || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                            </div>
                                        </div>

                                        {/* Listing Device */}
                                        <div
                                            className="field-block"
                                            style={{ borderBottom: 'none', padding: '0px' }}
                                        >
                                            <div className="field-label">Listing Device</div>
                                            <div className="field-value">
                                                {row.listing_device || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                            </div>
                                        </div>

                                        {/* Listing Brand */}
                                        <div
                                            className="field-block"
                                            style={{ borderBottom: 'none', padding: '0px', gridColumn: '1 / -1' }}
                                        >
                                            <div className="field-label">Listing Brand</div>
                                            <div className="field-value">
                                                {row.brand_hierarchy && row.brand_hierarchy.length > 0
                                                    ? row.brand_hierarchy.map(b => b.name).join(' >> ')
                                                    : (row.listing_brand || <span style={{ color: '#ADB5BD' }}>NA</span>)
                                                }
                                            </div>
                                        </div>

                                        {/* SPU */}
                                        <div
                                            className="field-block"
                                            style={{ borderBottom: 'none', padding: '0px' }}
                                        >
                                            <div className="field-label">SPU</div>
                                            <div className="field-value d-flex align-items-center" style={{ gap: '4px' }}>
                                                {row.spu  ? (
                                                    <>{!isArchived ?

                                                        (<><span
                                                            style={{ color: '#0D6EFD', cursor: 'pointer', fontWeight: 600 }}
                                                            onClick={() => { if (onSpuClick) onSpuClick(row); }}
                                                        >
                                                            {row.spu}
                                                            <SquareArrowOutUpRight
                                                            size={14}
                                                            strokeWidth={3}
                                                            style={{ color: '#0D6EFD', marginLeft: '4px', verticalAlign: 'text-top', flexShrink: 0 }}
                                                        />
                                                        </span>
                                                        </>) : (<div className="field-value">{row.spu}</div>)
                                                    }
                                                    </>
                                                ) : (
                                                    <span style={{ color: '#ADB5BD' }}>NA</span>
                                                )}
                                            </div>
                                        </div>

                                        {/* Open ID — full width */}
                                        <div
                                            className="field-block"
                                            style={{
                                                borderBottom:   'none',
                                                gridColumn:     '1 / -1',
                                                display:        'flex',
                                                flexDirection:  'column',
                                                alignItems:     'flex-start',
                                                width:          '100%',
                                                padding:'0px'

                                            }}
                                        >
                                            <div className="field-label" style={{ marginBottom: '10px' }}>Open ID</div>
                                            <div className="field-value" style={{ width: '100%', wordBreak: 'break-all' }}>
                                                {row.uuid ? (
                                                    <div className="field-value d-flex align-items-center gap-2">
                                                        <span
                                                            style={{
                                                                color:           '#0D6EFD',
                                                                cursor:          'pointer',
                                                                textDecoration:  'underline',
                                                                fontWeight:500
                                                            }}
                                                            onClick={() => handleCopy(row.uuid)}
                                                        >
                                                            {row.uuid}
                                                            <Copy
                                                                size={13}
                                                                style={{ cursor: 'pointer', color: '#0D6EFD', marginLeft: '6px',fontWeight:500 }}
                                                            />
                                                        </span>
                                                        {copied && (
                                                            <span style={{ fontSize: '12px', color: '#0D6EFD' }}>
                                                                Copied!
                                                            </span>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <span style={{ color: '#ADB5BD' }}>NA</span>
                                                )}
                                            </div>
                                        </div>

                                        {/* Created By */}
                                        <div
                                            className="field-block"
                                            style={{ borderBottom: 'none', padding: '0px' }}
                                        >
                                            <div className="field-label">Created By</div>
                                            <div className="field-value">
                                                {row.created_by || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                            </div>
                                        </div>

                                        {/* Created Time */}
                                        <div
                                            className="field-block"
                                            style={{ borderBottom: 'none', padding: '0px' }}
                                        >
                                            <div className="field-label">Created Time</div>
                                            <div className="field-value">
                                                {formatDateTime(row.created_at) || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                            </div>
                                        </div>

                                        {/* Last Modified By */}
                                        <div
                                            className="field-block"
                                            style={{ borderBottom: 'none', padding: '0px' }}
                                        >
                                            <div className="field-label">Last Modified By</div>
                                            <div className="field-value">
                                                {row.modified_by || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                            </div>
                                        </div>

                                        {/* Last Modified Time */}
                                        <div
                                            className="field-block"
                                            style={{ borderBottom: 'none', padding: '0px' }}
                                        >
                                            <div className="field-label">Last Modified Time</div>
                                            <div className="field-value">
                                                {formatDateTime(row.modified_at) || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                            </div>
                                        </div>

                                        {/* Archived By + Archived Time (only for archived listings) */}
                                        {isArchived && (
                                            <>
                                                <div
                                                    className="field-block"
                                                    style={{ borderBottom: 'none', padding: '0px' }}
                                                >
                                                    <div className="field-label">Archived By</div>
                                                    <div className="field-value">
                                                        {row.archived_by || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                    </div>
                                                </div>

                                                <div
                                                    className="field-block"
                                                    style={{ borderBottom: 'none', padding: '0px' }}
                                                >
                                                    <div className="field-label">Archived Time</div>
                                                    <div className="field-value">
                                                        {formatDateTime(row.archived_at) || <span style={{ color: '#ADB5BD' }}>NA</span>}
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* ════════ ADDITIONAL TAB ════════ */}
                        {drawerTab === 'additional-info' && (
                            <div
                                className="card-section"
                                style={{
                                    borderRadius: '12px',
                                    boxShadow:    '0px 4px 12px rgba(0, 0, 0, 0.08)',
                                    overflow:     'hidden',
                                    marginTop:    '40px',
                                }}
                            >
                                {/* Card header */}
                                <div
                                    className="card-header"
                                    style={{
                                        backgroundColor: '#F8F9FA',
                                        padding:         '10px 16px',
                                        fontFamily:      'Montserrat',
                                        fontSize:        '14px',
                                        fontWeight:       600,
                                        color:           '#212529',
                                        borderBottom:'none'
                                    }}
                                >
                                    Notes
                                </div>

                                {/* Card body */}
                                <div
                                    className="card-body"
                                    style={{
                                        backgroundColor: '#FFFFFF',
                                        padding:         '16px',
                                        display:         'flex',
                                        flexDirection:   'column',
                                        gap:             '12px',
                                        wordBreak:       'break-word',
                                        overflowWrap:    'break-word',
                                        whiteSpace:      'normal',
                                    }}
                                >
                                    <div className="field-block">
                                        <div
                                            className="field-value notes-preserve"
                                            style={{
                                                background: '#FFFFFF',
                                                padding:    '8px 0',
                                                fontSize:   '14px',
                                                color:      row.notes ? '#212529' : '#ADB5BD',
                                                minHeight:  '24px',
                                            }}
                                        >
                                            {row.notes || 'NA'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </>
    );
};

export default TradeInListingDrawer;
